// Registro unico das metricas exibidas no painel de perfil.
//
// Existe para que aposentar ou adicionar um tile seja UMA linha aqui, e nao
// cirurgia de JSX em InstagramProfile.js + FacebookPageProfile.js. A Meta
// aposenta nomes de metrica com frequencia (page_fans, impressions,
// profile_views morreram entre 2024 e 2025) — quando a proxima cair, o backend
// devolve o grupo com metrics_dropped e basta remover a entrada daqui.
//
// key    — nome exato da metrica no envelope (totals/node)
// i18n   — sufixo em settings.json: socialAccounts.metrics.label.<i18n>
// icon   — Iconify
// tone   — cor do card (MetricCard)
// format — como renderizar o numero

export const FORMAT = {
    NUMBER: 'number',
    RATING: 'rating',
};

// ── Instagram ────────────────────────────────────────────────────────────

export const IG_NODE_METRICS = [
    { key: 'followers_count', i18n: 'followers', icon: 'eva:people-outline', tone: 'violet' },
    { key: 'follows_count', i18n: 'following', icon: 'eva:person-add-outline', tone: 'slate' },
    { key: 'media_count', i18n: 'posts', icon: 'eva:grid-outline', tone: 'slate' },
];

export const IG_PERFORMANCE_METRICS = [
    { key: 'reach', i18n: 'reach', icon: 'eva:radio-button-on-outline', tone: 'violet' },
    { key: 'views', i18n: 'views', icon: 'eva:eye-outline', tone: 'blue' },
    { key: 'total_interactions', i18n: 'totalInteractions', icon: 'eva:flash-outline', tone: 'amber' },
    { key: 'accounts_engaged', i18n: 'accountsEngaged', icon: 'eva:people-outline', tone: 'green' },
    { key: 'likes', i18n: 'likes', icon: 'eva:heart-outline', tone: 'rose' },
    { key: 'comments', i18n: 'comments', icon: 'eva:message-circle-outline', tone: 'blue' },
    { key: 'shares', i18n: 'shares', icon: 'eva:share-outline', tone: 'slate' },
    { key: 'saves', i18n: 'saves', icon: 'eva:bookmark-outline', tone: 'slate' },
    { key: 'replies', i18n: 'replies', icon: 'eva:corner-up-left-outline', tone: 'slate' },
    { key: 'reposts', i18n: 'reposts', icon: 'eva:repeat-outline', tone: 'slate' },
    { key: 'profile_links_taps', i18n: 'profileLinksTaps', icon: 'eva:link-2-outline', tone: 'violet' },
    { key: 'follows_and_unfollows', i18n: 'netFollows', icon: 'eva:trending-up-outline', tone: 'green' },
];

// ── Facebook ─────────────────────────────────────────────────────────────

export const FB_NODE_METRICS = [
    { key: 'followers_count', i18n: 'followers', icon: 'eva:people-outline', tone: 'violet' },
    { key: 'fan_count', i18n: 'likes', icon: 'eva:heart-outline', tone: 'rose' },
    { key: 'talking_about_count', i18n: 'talkingAbout', icon: 'eva:message-square-outline', tone: 'blue' },
    { key: 'overall_star_rating', i18n: 'rating', icon: 'eva:star-outline', tone: 'amber', format: FORMAT.RATING },
    { key: 'new_like_count', i18n: 'newLikes', icon: 'eva:person-add-outline', tone: 'green' },
    { key: 'engagement_count', i18n: 'engagement', icon: 'eva:flash-outline', tone: 'amber' },
    { key: 'checkins', i18n: 'checkins', icon: 'eva:pin-outline', tone: 'slate' },
    { key: 'were_here_count', i18n: 'wereHere', icon: 'eva:navigation-2-outline', tone: 'slate' },
];

export const FB_PERFORMANCE_METRICS = [
    { key: 'page_views_total', i18n: 'pageViews', icon: 'eva:eye-outline', tone: 'blue' },
    { key: 'page_post_engagements', i18n: 'postEngagements', icon: 'eva:flash-outline', tone: 'amber' },
    { key: 'page_total_actions', i18n: 'pageActions', icon: 'eva:cursor-outline', tone: 'violet' },
    { key: 'page_media_view', i18n: 'mediaViews', icon: 'eva:image-outline', tone: 'blue' },
    { key: 'page_total_media_view_unique', i18n: 'peopleReached', icon: 'eva:people-outline', tone: 'violet' },
    { key: 'page_follows', i18n: 'followersTotal', icon: 'eva:person-done-outline', tone: 'green' },
    { key: 'page_daily_follows_unique', i18n: 'newFollows', icon: 'eva:person-add-outline', tone: 'green' },
    { key: 'page_daily_unfollows_unique', i18n: 'unfollows', icon: 'eva:person-remove-outline', tone: 'rose' },
    { key: 'page_lifetime_engaged_followers_unique', i18n: 'engagedFollowers', icon: 'eva:heart-outline', tone: 'rose' },
    { key: 'page_video_views', i18n: 'videoViews', icon: 'eva:play-circle-outline', tone: 'blue' },
    { key: 'page_video_views_organic', i18n: 'videoViewsOrganic', icon: 'eva:sun-outline', tone: 'slate' },
    { key: 'page_video_views_paid', i18n: 'videoViewsPaid', icon: 'eva:credit-card-outline', tone: 'slate' },
];

// Series com grafico de evolucao. `metric` e a chave dentro de envelope.series.
export const IG_SERIES = [
    { metric: 'reach', i18n: 'reach', color: '#7C3AED' },
    { metric: 'follower_count', i18n: 'followers', color: '#059669' },
];

export const FB_SERIES = [
    { metric: 'page_media_view', i18n: 'mediaViews', color: '#7C3AED' },
    { metric: 'page_daily_follows_unique', i18n: 'newFollows', color: '#059669' },
];

// Ordem fixa das superficies do Instagram — a Meta devolve as chaves sem ordem
// e alternar a posicao entre recargas atrapalha a leitura.
export const MEDIA_PRODUCT_ORDER = ['FEED', 'REELS', 'STORY', 'AD', 'CAROUSEL_CONTAINER', 'POST'];

export const PERIODOS = [7, 30, 90];

// ── Formatadores ─────────────────────────────────────────────────────────

/** 1234 -> "1.2K". Mesma regra ja usada na listagem de Contas Sociais. */
export function formatNumber(num) {
    const n = Number(num);
    if (!n) return '0';
    if (Math.abs(n) >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
    if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(1)}K`;
    return String(n);
}

export function formatMetricValue(valor, format) {
    if (format === FORMAT.RATING) return Number(valor).toFixed(1);
    return formatNumber(valor);
}

/** ISO -> "HH:MM" no locale do usuario. */
export function formatHora(iso, locale) {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleTimeString(locale || 'pt-BR', { hour: '2-digit', minute: '2-digit' });
    } catch (_) {
        return '';
    }
}

/**
 * Metricas com valor util no envelope.
 *
 * Metrica ausente NAO vira tile com "—" nem com zero: um zero inventado mente
 * sobre o dado tanto quanto um erro escondido. So `0` real (a chave existe)
 * e exibido.
 */
export function metricasDisponiveis(catalogo, fonte = {}) {
    return catalogo.filter((m) => fonte[m.key] !== undefined && fonte[m.key] !== null);
}
